export default "__VITE_ASSET__S32MDyVT__"